import {
  newPublication as newPublicationRepository,
  getOwnPublications as getOwnPublicationsRepository,
  deletePublication as deletePublicationRepository,
  getImagePublication as getImagePublicationRepository,
  loadImage as loadImageRepository,
  getOtherUserPublications as getOtherUserPublicationsRepository,
  getInteractionPermissions as getInteractionPermissionsRepository,
  getMainPublications as getMainPublicationsRepository,
  savePublication as savePublicationRepository,
  reactPublication as reactPublicationRepository,
  hidePublication as hidePublicationRepository,
  reportPublication as reportPublicationRepository,
  getSavedPublications as getSavedPublicationsRepository,
  commentPublication as commentPublicationRepository,
  getPublicationById as getPublicationByIdRepository,
  getListRecommendations as getListRecommendationsRepository,
  getRecomendations as getRecomendationsRepository,
  getSavedRecomendations as getSavedRecomendationsRepository,
  saveRecomendation as saveRecomendationRepository,
  notifySavedRecommendation as notifySavedRecommendationRepository,
  postImageRecomendation as postImageRecomendationRepository,
  getPublicationComments as getPublicationCommentsRepository,
  postPublicationReactions as postPublicationReactionsRepository,
  postListConnectionsAndFollowers as postListConnectionsAndFollowersRepository,
  getListPlacesOfInterest as getListPlacesOfInterestRepository,
  getHashtagPosts as getHashtagPostsRepository,
  getGeoLocations as getGeoLocationsRepository,
  postInsertOrUpdateGeolocation as postInsertOrUpdateGeolocationRepository,
  postEditComment as postEditCommentRepository,
  postDeleteComment as postDeleteCommentRepository,
  suggestMentions as suggestMentionsRepository,
  getCatalogForGoogle as getCatalogForGoogleRepository,
  translateText as translateTextRepository,
  translateDynamicText as translateDynamicTextRepository,
  searchRooms as searchRoomsRepository,
  getHousingSuggestions as getHousingSuggestionsRepository,
  getNomadSuggestions as getNomadSuggestionsRepository,
  getNearbyHousing as getNearbyHousingRepository,
  autocompleteSearch as autocompleteSearchRepository,
  getLocationPin as getLocationPinRepository,
  getRoomDetails as getRoomDetailsRepository,
  syncMapWithFilters as syncMapWithFiltersRepository,
} from "../repositories/PublicationRepository";
import {createCommentsResponse, createMainFeedResponse, createPublicationResponse} from "../mappers/PublicationsMapper";
import {createRequestResourceCache} from "../utils/requestResourceCache";
import {voidGuid} from "../../shared/constants/constants";

const HOME_DISCOVERY_CACHE_TTL_MS = 3000;
const homeDiscoveryCache = createRequestResourceCache({
  ttlMs: HOME_DISCOVERY_CACHE_TTL_MS,
});

const placesOfInterestCacheKey = (idUsuario) =>
  `places-of-interest:${String(idUsuario ?? "")}`;

const nomadSuggestionsCacheKey = (idUsuario) =>
  `nomad-suggestions:${String(idUsuario ?? "")}`;

export const newPublicationService = async (publication) => {
  try {
    return await newPublicationRepository(publication)
  } catch (error) {
    throw error
  }
}

export const loadImagePublicationService = async (imgData) => {
  try {
    return await loadImageRepository(imgData)
  } catch (error) {
    throw error
  }
}

// Paginado del feed propio. La primera pagina se pide solo con IdUsuario, que es
// el unico parametro obligatorio del endpoint, y el backend responde con 5. De
// ahi en adelante se pide con el ultimo id de la pagina anterior y se traen 10
// por vuelta, hasta que la respuesta venga vacia. Quien controla el cursor y el
// fin de la lista es la pantalla; aqui solo vive el tamano de pagina.
const OWN_FEED_PAGE_SIZE = 10;

export const getOwnPublicationsService = async (idUsuario, ultimoIdPublicacion) => {
  try {
    const isFirstPage =
      !ultimoIdPublicacion || String(ultimoIdPublicacion) === voidGuid;

    const publications = await getOwnPublicationsRepository(
      idUsuario,
      isFirstPage ? undefined : ultimoIdPublicacion,
      isFirstPage ? undefined : OWN_FEED_PAGE_SIZE,
    )
    return createPublicationResponse(publications)
  } catch (error) {
    throw error
  }
}

export const getImagePublicationService = async (imgId) => {
  try {
    return await getImagePublicationRepository(imgId)
  } catch (error) {
    throw error
  }
}

export const deletePublicationService = async (idPublication) => {
  try {
    return await deletePublicationRepository(idPublication)
  } catch (error) {
    throw error
  }
}

export const getOtherUserPublicationsService = async (pubsReq) => {
  try {
    const response = await getOtherUserPublicationsRepository(pubsReq)
    return {
      message: response?.message || "",
      publications: createPublicationResponse(response),
    }
  } catch (error) {
    throw error
  }
}

export const getInteractionPermissionsService = async (permissionsReq) => {
  try {
    return await getInteractionPermissionsRepository(permissionsReq)
  } catch (error) {
    throw error
  }
}

export const getMainPublicationsService = async (userId, publicationId) => {
  try {
    const publications = await getMainPublicationsRepository(userId, publicationId)
    return createPublicationResponse(publications)
  } catch (error) {
    throw error
  }
}

export const getMainFeedService = async (
  userId,
  publicationId,
  UltimoIdCupon,
  cantidad,
) => {
try {
   const items = await getMainPublicationsRepository(
     userId,
     publicationId,
     UltimoIdCupon,
     cantidad,
   );
  return createMainFeedResponse(items)
} catch (error) {
  throw error
} 
}

export const savePublicationService = async (userId, publicationId) => {
  try {
    return await savePublicationRepository(userId, publicationId)
  } catch (error) {
    throw error
  }
}

export const reactPublicationService = async (reactReq) => {
  try {
    return await reactPublicationRepository(reactReq)
  } catch (error) {
    throw error
  }
}

export const hidePublicationService = async (hideReq) => {
  try {
    return await hidePublicationRepository(hideReq)
  } catch (error) {
    throw error
  }
}

export const reportPublicationService = async (reportReq) => {
  try {
    return await reportPublicationRepository(reportReq)
  } catch (error) {
    throw error
  }
}

export const getSavedPublicationsService = async (userId, listId) => {
  try {
    const publications = await getSavedPublicationsRepository(userId, listId)
    return createPublicationResponse(publications)
  } catch (error) {
    throw error
  }
}

export const commentPublicationService = async (commentReq) => {
  try {
    return await commentPublicationRepository(commentReq)
  } catch (error) {
    throw error
  }
}

export const getPublicationByIdService = async (userId, publicationId) => {
  try {
    const publication = await getPublicationByIdRepository(userId, publicationId)
    const transformed = Array.isArray(publication) ? publication : [publication]
    return createPublicationResponse(transformed)
  } catch (error) {
    throw error
  }
}

export const getListRecommendationsService = async (lang) => {
  try {
    return await getListRecommendationsRepository(lang)
  } catch (error) {
    throw error
  }
}

export const getListPlacesOfInterestService = async (idUsuario, options = {}) => {
  const key = placesOfInterestCacheKey(idUsuario);

  return homeDiscoveryCache.read(
    key,
    () => getListPlacesOfInterestRepository(idUsuario),
    { force: options.forceRefresh === true },
  );
}

export const invalidatePlacesOfInterestCache = (idUsuario) => {
  homeDiscoveryCache.invalidate(placesOfInterestCacheKey(idUsuario));
}


export const getRecomendationsService = async (query) => {
  try {
    return await getRecomendationsRepository(query)
  } catch (error) {
    throw error
  }
}

export const getSavedRecomendationsService = async (id) => {
  try {
    return await getSavedRecomendationsRepository(id)
  } catch (error) {
    throw error
  }
}

export const saveRecomendationService = async (id, jsonValue) => {
  try {
    const response = await saveRecomendationRepository(id, jsonValue)
    // El estado guardado cambió: una navegación posterior no debe reutilizar
    // el resultado anterior de /api/recomendaciones/gmaps.
    invalidatePlacesOfInterestCache(id);
    return response
  } catch (error) {
    throw error
  }
}

export const notifySavedRecommendationService = async (payload) => {
  try {
    return await notifySavedRecommendationRepository(payload)
  } catch (error) {
    throw error
  }
}

export const postImageRecomendationService = async (photo) => {
  try {
    return await postImageRecomendationRepository(photo)
  } catch (error) {
    throw error
  }
}

export const getPublicationCommentsService = async (commentReq) => {
  try {
    const comments = await getPublicationCommentsRepository(commentReq)
    return createCommentsResponse(comments)
  } catch (error) {
    throw error
  }
}

export const postReactionComentary = async (reactReq) => {
  try {
    return await postPublicationReactionsRepository(reactReq)
  } catch (error) {
    throw error
  }
}

export const postListConnectionsAndFollowersService = async (data) => {
  try {
    return await postListConnectionsAndFollowersRepository(data)
  } catch (error) {
    throw error
  }
}

export const getHashtagPostsService = async (data) => {
  try {
    const publications = await getHashtagPostsRepository(data)
    return createPublicationResponse(publications)
  } catch (error) {
    throw error
  }
}

// Obtener geo ubicaciones
export const getGeoLocationsService = async (idEntidad) => {
  try {
    return await getGeoLocationsRepository(idEntidad)
  } catch (error) {
    throw error
  }
}

// Insertar o actualizar geo ubicación
export const postInsertOrUpdateGeolocationService = async (data) => {
  try {
    return await postInsertOrUpdateGeolocationRepository(data)
  } catch (error) {
    throw error
  }
}

// Editar comentario
export const postEditCommentService = async (data) => {
  try {
    return await postEditCommentRepository(data)
  } catch (error) {
    throw error
  }
}

// Eliminar comentario
export const postDeleteCommentService = async (data) => {
  try {
    return await postDeleteCommentRepository(data)
  } catch (error) {
    throw error
  }
}

// Menciones (arrobados)
export const suggestMentionsService = async (data) => {
  try {
    return await suggestMentionsRepository(data)
  } catch (error) {
    throw error
  }
}

// Idiomas soportados por Google
export const getCatalogForGoogleService = async (language) => {
  try {
    return await getCatalogForGoogleRepository(language)
  } catch (error) {
    throw error
  }
}

// Traducción de texto
const MAX_TRANSLATION_CHUNK_LENGTH = 400;

const splitTextForTranslation = (text) => {
  const tokens = text.match(/\S+\s*/g) || [];
  const chunks = [];
  let currentChunk = "";

  tokens.forEach((token) => {
    if (
      currentChunk &&
      currentChunk.length + token.length > MAX_TRANSLATION_CHUNK_LENGTH
    ) {
      chunks.push(currentChunk);
      currentChunk = "";
    }

    if (token.length > MAX_TRANSLATION_CHUNK_LENGTH) {
      for (
        let index = 0;
        index < token.length;
        index += MAX_TRANSLATION_CHUNK_LENGTH
      ) {
        if (currentChunk) chunks.push(currentChunk);
        currentChunk = token.slice(
          index,
          index + MAX_TRANSLATION_CHUNK_LENGTH,
        );
      }
    } else {
      currentChunk += token;
    }
  });

  if (currentChunk) chunks.push(currentChunk);
  return chunks;
};

export const translateTextService = async (data) => {
  try {
    const text = typeof data?.text === "string" ? data.text : "";
    if (text.length <= MAX_TRANSLATION_CHUNK_LENGTH) {
      return await translateTextRepository(data)
    }

    const chunks = splitTextForTranslation(text);
    const translatedChunks = [];
    let responseMetadata = {};

    for (const chunk of chunks) {
      const trailingWhitespace = chunk.match(/\s+$/)?.[0] || " ";
      const response = await translateTextRepository({
        ...data,
        text: chunk.trimEnd(),
      });
      responseMetadata = response || responseMetadata;
      translatedChunks.push(`${response?.text || ""}${trailingWhitespace}`);
    }

    return {
      ...responseMetadata,
      text: translatedChunks.join("").trimEnd(),
    };
  } catch (error) {
    throw error
  }
}

// Traducción de textos dinámicos
export const translateDynamicTextService = async (data) => {
  try {
    return await translateDynamicTextRepository(data)
  } catch (error) {
    throw error
  }
}

// Busqueda de habitaciones
export const searchRoomsService = async (data) => {
  try {
    return await searchRoomsRepository(data)
  } catch (error) {
    throw error
  }
}

// Obtener sugerencias housing
export const getHousingSuggestionsService = async () => {
  try {
    return await getHousingSuggestionsRepository()
  } catch (error) {
    throw error
  }
}

// Mostrar los cinco inmuebles cerca de la ubicación buscada
export const getNomadSuggestionsService = async (idUsuario, options = {}) => {
  return homeDiscoveryCache.read(
    nomadSuggestionsCacheKey(idUsuario),
    () => getNomadSuggestionsRepository(idUsuario),
    { force: options.forceRefresh === true },
  );
}

export const getNearbyHousingService = async (data) => {
  try {
    return await getNearbyHousingRepository(data)
  } catch (error) {
    throw error
  }
}

// Autocompletar búsqueda
export const autocompleteSearchService = async (data) => {
  try {
    return await autocompleteSearchRepository(data)
  } catch (error) {
    throw error
  }
}

// Mostrar pin con ubicación
export const getLocationPinService = async (data) => {
  try {
    return await getLocationPinRepository(data)
  } catch (error) {
    throw error
  }
}

// Obtener detalles de la habitación
export const getRoomDetailsService = async (data) => {
  try {
    return await getRoomDetailsRepository(data)
  } catch (error) {
    throw error
  }
}

// Sincronizar el mapa con todos los filtros de búsqueda
export const syncMapWithFiltersService = async (data) => {
  try {
    return await syncMapWithFiltersRepository(data)
  } catch (error) {
    throw error
  }
}
